import { Route, withRouter, Redirect } from 'react-router-dom';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import pageTitles from 'enums/pageTitles';
import history from '../../store/history';

const PrivateRoute = ({
  path,
  component: Component,
  allow,
  redirectTo,
  requiresAccount,
  currentAccount,
  ...rest
}) => {
  const isAuth = useSelector(state => state.auth.isAuth);

  history.location.state = { ...history.location.state };

  // Store the current path as callback if user is not authenticated and trying to access a protected route
  useEffect(() => {
    if (!isAuth && !allow && history.location.pathname) {
      // Only save paths that are not login-related
      const pathname = history.location.pathname;
      if (
        !pathname.includes('/login') &&
        !pathname.includes('/reset_password') &&
        !pathname.includes('/request_success') &&
        !pathname.includes('/onboarding') &&
        !pathname.includes('/magic-link-password') &&
        !pathname.includes('/create_success') &&
        !pathname.includes('/new_password') &&
        pathname !== '/'
      ) {
        sessionStorage.setItem('callback', pathname);
      }
    }
  }, [isAuth, allow, history.location.pathname]);

  useEffect(() => {
    document.title = pageTitles[history.location.pathname] || 'Fitness SF';
  }, [path]);

  // 403 page is rendering when user is logged in but access is not allowed
  // By passing "redirectTo" prop you can redirect user to specific page.
  return (
    <Route
      {...rest}
      render={props => (allow ? <Component {...props} /> : <Redirect to={redirectTo} />)}
    />
  );
};

PrivateRoute.propTypes = {
  forbidden: PropTypes.bool,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }),
  path: PropTypes.string.isRequired,
  component: PropTypes.object.isRequired,
  allow: PropTypes.bool.isRequired,
  requiresAccount: PropTypes.bool,
  currentAccount: PropTypes.object,
  redirectTo: PropTypes.string,
  pageMeta: PropTypes.object,
};

PrivateRoute.defaultProps = {
  pageMeta: {},
  forbidden: false,
  redirectTo: '/',
  requiresAccount: false,
  currentAccount: null,
  history: {
    goBack: () => {
      return null;
    },
  },
};

export default withRouter(PrivateRoute);
